import serviceOrdersRoutes from './serviceOrders'

export default [
  ...serviceOrdersRoutes
]
